import { TopBar } from './TopBar';
import PageHeaderCapsuleButton from './PageHeaderCapsuleButton';
import './AuthFlowLayout.css';

export default function AuthFlowLayout({
    children,
    title,
    titleRef,
    onBack,
    backLabel = 'Back',
    logoInteractive = true,
    showHeader = true,
    className = '',
}) {
    return (
        <main className={`container appScreen authFlowPage ${className}`.trim()}>
            {showHeader && <TopBar
                hideAuthAction
                logoInteractive={logoInteractive}
                trailingAction={onBack && (
                    <PageHeaderCapsuleButton
                        type='button'
                        aria-label={backLabel}
                        onClick={onBack}
                    >
                        Back
                    </PageHeaderCapsuleButton>
                )}
            />}
            <div className='authFlowContent'>
                {title && <h1 ref={titleRef} tabIndex={titleRef ? -1 : undefined} className='authFlowTitle'>{title}</h1>}
                {children}
            </div>
        </main>
    );
}
